<template>
  <div class="price">
		<img src="./assets/price.png" alt="月額 3,980円（税込）">
  </div>
</template>
<script scoped>
export default {
  props: ['linkToPaymentPage']
}
</script>
<style>
.price {
	margin-top: 2em;
	margin-bottom: 4em;
}



</style>
